import { render, staticRenderFns } from "./abnormal-order.vue?vue&type=template&id=183de285&"
import script from "./abnormal-order.vue?vue&type=script&lang=js&"
export * from "./abnormal-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports